export default {"src":"/_next/static/media/FOXA.e3e496e2.svg","height":18,"width":18};